import React, { useState } from 'react';
import './FeedbackModal.css';

function FeedbackModal({ isOpen, onClose, onSubmit }) {
  const [formData, setFormData] = useState({
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setError(''); // Clear error when user types
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validation
    if (!formData.subject.trim()) {
      setError('Subject is required');
      return;
    }

    if (!formData.message.trim()) {
      setError('Message is required');
      return;
    }

    if (formData.message.length < 10) {
      setError('Message must be at least 10 characters');
      return;
    }

    setIsSubmitting(true);

    try {
      await onSubmit(formData);
      // Reset form on success
      setFormData({ subject: '', message: '' });
      onClose();
    } catch (err) {
      setError(err.message || 'Failed to submit feedback. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    if (!isSubmitting) {
      setFormData({ subject: '', message: '' });
      setError('');
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="feedback-modal-overlay" onClick={handleClose}>
      <div className="feedback-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="feedback-modal-header">
          <h2>💬 Send Feedback</h2>
          <button 
            className="modal-close-btn" 
            onClick={handleClose}
            disabled={isSubmitting}
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="feedback-form">
          {error && (
            <div className="feedback-error">
              ⚠️ {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="subject">Subject *</label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              placeholder="Brief description of your feedback..."
              maxLength={255}
              disabled={isSubmitting}
              required
            />
            <small className="char-count">
              {formData.subject.length}/255 characters
            </small>
          </div>

          <div className="form-group">
            <label htmlFor="message">Message *</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Please provide detailed feedback. What's working well? What could be improved? Any bugs or issues?"
              rows={8}
              disabled={isSubmitting}
              required
            />
            <small className="char-count">
              {formData.message.length} characters (minimum 10)
            </small>
          </div>

          <div className="feedback-modal-actions">
            <button
              type="button"
              className="btn-secondary"
              onClick={handleClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={isSubmitting || formData.message.length < 10}
            >
              {isSubmitting ? 'Sending...' : '📤 Send Feedback'}
            </button>
          </div>
        </form>

        <div className="feedback-note">
          <span className="note-icon">ℹ️</span>
          <p>Your feedback helps us improve The Ascended platform. We read every submission!</p>
        </div>
      </div>
    </div>
  );
}

export default FeedbackModal;
